const mEditionProductPagesOfGratefulnessModalCreateExternalSite = {
  mEditionProductPagesOfGratefulnessModalCreateExternalSite: {
    alerts: {
      createProductoPaginaIdroop: {
        error: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.',
        success: 'La página de agradecimiento fue creada exitosamente.'
      }
    },

    buttonCancel: 'CANCELAR',
    buttonPrimary: 'CREAR',

    inputs: {
      nombre: {
        label: 'Escribe aquí un nombre para la página de agradecimiento',
        message: '* De 1 a 60 caracteres',
        placeholder: 'Mi Página de Agradecimiento Externa'
      },

      url: {
        label: 'Escribe aquí la URL del enlace externo',
        placeholder: 'https://www.mi-pagina-de-agradecimiento-externa.com'
      }
    },

    quote: 'Aquí puedes conectar tu página de agradecimiento creada en con alguna herramienta externa a Vidroop (ej. optimizepress, leadpage, etc).',
    title: 'AGREGAR PÁGINA',

    validation: {
      nombre: {
        maxLength: 'La longitud máxima permitida es de 60 caracteres.',
        minLength: 'La longitud mínima permitida es de 1 caracter.',
        required: 'Nombre de página de agradecimiento es requerido.'
      },

      url: {
        required: 'Url externa de página de agradecimiento es requerida.',
        url: 'La dirección de enlace externo debe ser url válida. '
      }
    }
  }
}

export default mEditionProductPagesOfGratefulnessModalCreateExternalSite
